var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Seite konnte nicht geladen werden")]),_c('p',[_vm._v("Die angefragte Seite ist leider nicht erreichbar")]),_c('v-btn',{staticClass:"mt-12",attrs:{"tile":"","outlined":"","color":"error"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" zurück ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }